module.exports = {
          srcSet: __webpack_public_path__ + "8db098bde33b8085e6cae5979f1efd6e-66.png"+" 66w",
          images:[ {path: __webpack_public_path__ + "8db098bde33b8085e6cae5979f1efd6e-66.png",width: 66,height: 34}],
          src: __webpack_public_path__ + "8db098bde33b8085e6cae5979f1efd6e-66.png",
          toString:function(){return __webpack_public_path__ + "8db098bde33b8085e6cae5979f1efd6e-66.png"},
          
          width: 66,
          height: 34
        }